// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App'; // eslint-disable-line
import '@/util/rem';
import {supreme} from '@/supreme-core';
import util from '@/util/util';
import VueI18n from 'vue-i18n';
import initLanguages from '@/assets/languages';

import Vuebar from 'vuebar';
import { Lazyload } from 'vant';
import { router } from './router';
import store from './store/store';

Vue.use(Vuebar);

supreme.init({
  $router: router,
  defaultJumpPath: '/index'
});
let main = {
  bindEvents() {
  },
  // 初始化基类
  initBaseData(callback) {
    Vue.prototype.$EventBus = new Vue();

    //  是否复用官网的报错页面
    Vue.prototype.$goError = () => {
      window.location.href = 'https://www.nio.com/404';
    };
    Vue.use(VueI18n);
    // 注册图片懒加载组件
    Vue.use(Lazyload, {
      preLoad: 1.3,
      loading:  require('@/assets/images/placeholder.png'),
      error:  require('@/assets/images/placeholder.png'),
      attempt: 2
    });
    callback();
  },
  async initVue() {
    const pathName = window.location.pathname
    let locale = pathName.split('/')[1]
    if (!/[a-z]{2}_[A-Z]{2}/.test(locale)) {
      locale = 'no_NO'
    }
    const location = util.getLangAndRegionFromLocale(locale)
    const lang = location.lang
    initLanguages(lang, () => {
      // 获取语言包
      this.initBaseData(() => {
        const i18n = new VueI18n({
          local: lang, // 设置语言 
          fallbackLocale: lang,
          messages: {
            [lang]: window.WWW_EDITOR_CONTENT_PAGE_ACTIVITY_DETAIL
          },
        });
        Vue.prototype.$location = location
        return new Vue({
          el: '#app',
          i18n,
          router,
          store: store,
          render: (h) => h(App)
        });
      });
    })
  },
  init() {
    this.initVue();
  }
};

main.init();
